<template>
  <b-card-actions action-collapse title="Booking">
    <div>
      <div>
        <b-form>
           <b-row
            v-for="(item, index) in items"
            :id="item.id"
            :key="item.id"
            ref="row"
          >
           <b-col b-col cols="12" lg="3" md="3" sm="4" >
              <b-form-group
                label="Ship name"
                label-for="shipName"
              >
                <b-form-input
                  id="shipName"
                  type="text"
                  v-model="item.shipName"
                />
              </b-form-group>
            </b-col>

      <b-col b-col cols="12" lg="3" md="3" sm="4" >
              <b-form-group
                label="traval Number "
                label-for="travalNumber"
              >
                <b-form-input
                  id="travalNumber"
                  type="text"
                  v-model="item.travalNumber"
                />
              </b-form-group>
            </b-col>
             <b-col b-col cols="12" lg="3" md="3" sm="4" >
              <b-form-group
                label="departure Port"
                label-for="departurePort"
              >
                <b-form-input
                  id="departurePort"
                  type="text"
                  v-model="item.departurePort"
                />
              </b-form-group>
            </b-col>
              <b-col b-col cols="12" lg="3" md="3" sm="4" >
              <b-form-group
                label="destination Port"
                label-for="destinationPort"
              >
                <b-form-input
                  id="destinationPort"
                  type="text"
                  v-model="item.destinationPort"
                />
              </b-form-group>
            </b-col>

                  <b-col b-col cols="12" lg="3" md="3" sm="4" >
              <b-form-group
                label="ETA"
                label-for="ETA"
              >
                <b-form-input
                  id="ETA"
                  type="date"
                  v-model="item.ETA"
                />
              </b-form-group>
            </b-col>
 <b-col b-col cols="12" lg="3" md="3" sm="4" >
              <b-form-group
                label="ETB"
                label-for="ETB"
              >
                <b-form-input
                  id="ETB"
                  type="date"
                  v-model="item.ETB"
                />
              </b-form-group>
            </b-col>
             <b-col b-col cols="12" lg="3" md="3" sm="4" >
              <b-form-group
                label="ETD"
                label-for="ETD"
              >
                <b-form-input
                  id="ETD"
                  type="date"
                  v-model="item.ETD"
                />
              </b-form-group>
            </b-col>
               <b-col 
                  v-if="index > 0"
                  lg="3"
                  md="3"
                >
                  <b-button 
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="mt-0 mt-md-2 ml-1"
                    @click="removeItem(index)"
                  >
                    <feather-icon icon="XIcon" /> Delete
                  </b-button>

                </b-col>

                <b-col cols="12">
                  <hr>
                </b-col>

           </b-row>
          <!-- ref="form"
            :style="{height: trHeight}"
            class="repeater-form"
            @submit.prevent="repeateAgain" 
          -->
          <!-- <b-row
            v-for="(item, index) in items"
            :id="item.id"
            :key="item.id"
            ref="row"
          >
            <b-col b-col cols="12" lg="3" md="3" sm="4" >
              <b-form-group
                label="Start date"
                label-for="beginDate"
              >
                <b-form-input
                  id="beginDate"
                  type="date"
                  v-model="item.beginDate"
                />
              </b-form-group>
            </b-col>

            <b-col b-col cols="12" lg="3" md="3" sm="4" >
              <b-form-group
                label="End date"
                label-for="endDate"
              >
                <b-form-input
                  id="endDate"
                  type="date"
                  v-model="item.endDate"
                />
              </b-form-group>
            </b-col>
      
            <b-col b-col cols="12" lg="6" md="6" sm="6" >
              <b-row v-for="(port, i) in item.portTabs"
                :id="port.id"
                :key="i"
                >
                <b-col b-col cols="12" lg="4" md="4" sm="6" >
                    <b-form-group
                      label="Departure port"
                      label-for="departurePort"
                    >
                      <b-form-select
                        :options="Portoptions"
                        id="departurePort"
                        v-model="port.departurePort"
                        />
                    </b-form-group>
                </b-col>

                <b-col b-col cols="12" lg="4" md="4" sm="6" >
                    <b-form-group
                      label="Destination port"
                      label-for="destinationPort"
                    >
                      <b-form-select
                        v-model="port.destinationPort"
                        :options="Portoptions"
                        id="destinationPort"
                        />
                    </b-form-group>
                </b-col>

                <b-col lg="1" md="1" cols="12" class="mb-50">
                    <b-button
                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                      variant="outline-success"
                      class="mt-0 mt-md-2"
                      @click="repeateAgainPorts(index)"
                    >
                      <feather-icon icon="PlusIcon"/>
                    </b-button>
                </b-col>

                <b-col 
                  v-if="index > 0 || i > 0"
                  lg="1"
                  md="1"
                >
                  <b-button v-if="i > 0"
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="mt-0 mt-md-2 ml-1"
                    @click="removeItemPort(index,i)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>

                  <b-button v-else
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="mt-0 mt-md-2 ml-1"
                    @click="removeItem(index)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>

                </b-col>

                <b-col cols="12">
                  <hr>
                </b-col>

              </b-row>
            </b-col>
          </b-row > -->
        </b-form>
      </div>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="repeateAgain"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-25"
        />
        <span>Add New</span>
      </b-button>
    </div>
  </b-card-actions>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BForm, 
  BFormGroup, 
  BFormInput, 
  BRow, 
  BCol, 
  BButton,
  BFormSelect,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BCardActions,
    BFormSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      items: [{
        id: 1,
        ETA: '',
        ETB: '',
        ETD:'',
        shipName:'',
        travalNumber:'',
        departurePort:'',
        destinationPort:'',

        // portTabs: [
        //   {
        //     id:1,
        //     departurePort: null,
        //     destinationPort: null,
        //   }
        // ]
        
      }],
      nextTodoId: 2,
        Portoptions: [
        { value: null, text: 'Please select an option' },
        { value: 'Tunis', text: 'Port Tunis' },
        { value: 'Allemagne', text: 'Port Allemagne' },
        { value: 'America', text: 'Port America' },
        { value: 'France', text: 'Port France'},
      ],

    }
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
        ETA: '',
        ETB: '',
        ETD:'',
        shipName:'',
        departurePort:'',
        destinationPort:'',
        travalNumber:'',
      })
      // this.$nextTick(() => {
      //   this.trAddHeight(this.$refs.row[0].offsetHeight)
      // })
    },
    // repeateAgainPorts(index) {
    //   this.items[index].portTabs.push({
    //     portTabs: [
    //       {
    //         departurePort: null,
    //         destinationPort: null,
    //       }
    //     ] 
    //   })
    // },
    // removeItemPort(index,i){
    //    this.items[index].portTabs.splice(i, 1)
    // },
    removeItem(index) {
      this.items.splice(index, 1)
      // this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    // initTrHeight() {
    //   this.trSetHeight(null)
    //   this.$nextTick(() => {
    //     this.trSetHeight(this.$refs.form.scrollHeight)
    //   })
    // },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
 